/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiPersonCategory {
    COUNTERPARTY = 'COUNTERPARTY',
    CUSTOMER = 'CUSTOMER'
}


export function instanceOfInternalApiPersonCategory(value: any): boolean {
    for (const key in InternalApiPersonCategory) {
        if (Object.prototype.hasOwnProperty.call(InternalApiPersonCategory, key)) {
            if (InternalApiPersonCategory[key as keyof typeof InternalApiPersonCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiPersonCategoryFromJSON(json: any): InternalApiPersonCategory {
    return InternalApiPersonCategoryFromJSONTyped(json, false);
}

export function InternalApiPersonCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonCategory {
    return json as InternalApiPersonCategory;
}

export function InternalApiPersonCategoryToJSON(value?: InternalApiPersonCategory | null): any {
    return value as any;
}

export function InternalApiPersonCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiPersonCategory {
    return value as InternalApiPersonCategory;
}

